module.exports = __webpack_public_path__ + "static/media/82.166bb7ca.png";